import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Container, { OfferButton, Beta, NoBold } from './styles';
import Title from '../../components/Title';
import scrollToTop from '../../utils/scrollToTop';
import illustrationHero from '../../Assets/Images/illustrationHero.jpg';

const Home = ({ toggleModal, isConnected }) => {
  const [inputValue, setInputValue] = useState('');

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <Container>
        <Beta>
            <p className="pt-2">
              Le site est actuellement en version bêta <NoBold>(des mises à jour arrivent très bientôt)</NoBold>
            </p>
        </Beta>
      {window.innerWidth >= 992 ? (
        <img
          className="illustration"
          src={illustrationHero}
          alt="illustration-hero"
           />
      ) : (
        <>
          <Title>Adopte dès maintenant&#xA0;&#x21;</Title>
        </>
      )}

      <OfferButton onClick={isConnected ? toggleModal : () => {}}>
        Offrir un villageois
      </OfferButton>
      <Link to="/search" className="searchLink">
        Rechercher un villageois
      </Link>
    </Container>
  );
};

Home.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  isConnected: PropTypes.bool.isRequired,
};

export default Home;
